import React from "react";

import { useOrganization } from "#/contexts/OrganizationContext";

export function MissingBillingInfoBanner() {
  const organization = useOrganization();

  return (
    !organization?.are_billing_info_complete &&
    organization?.active_checkout_link && (
      <div className="text-center bg-orange-500 text-destructive-foreground px-6 py-2.5 sm:px-3.5 sm:before:flex-1 text-sm leading-6 font-semibold">
        <a href="/settings/organization" className="underline">
          Você tem uma assinatura pendente. Antes de continuar, clique aqui para
          verificar que suas informações de cobrança estão atualizadas.
        </a>
      </div>
    )
  );
}
